module.exports = __webpack_public_path__ + "img/box-switchDiagplan.90038b10.png";